import React, {useRef, useEffect} from 'react'
import { useSelector } from 'react-redux'
import IframeResizer from "iframe-resizer-react";

export default function IframePopup({data, onModalClose}) {
  let html = ""

  const tagOwner = useSelector(state => state.tagOwner)
  let iframeUrl = data?.iframeData?.iframe_url


  if(tagOwner && tagOwner.id && iframeUrl) {
    iframeUrl = iframeUrl.replace(/@tag_owner_id@/g, tagOwner.id)
  }

  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <IframeResizer
            log
            src={iframeUrl}
            style={{ width: '1px', minWidth: '100%'}}
            frameBorder="0"
            // scrolling="no"
            allow="autoplay"
            sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  </div>
}
